<template>
  <transition name="fade">
    <div
      class="modal"
      v-if="show"
      style="z-index:1001;"
    >
      <div class="container">
        <div class="container_top el-message-box__header msp_icon_close">
          <span
            class="container_top_title"
            v-if='auditType=="canclePushArticle"'
          >下线已推送的稿件</span>
          <span
            class="iconfont el-icon-close"
            v-on:click="closeAudit()"
          ></span>
        </div>
        <div style="color:#333333;font-size:14px;padding:10px;">确认下线已推送的稿件:</div>
        <div class="delete_info">
          <span
            v-if='articleObj && auditType=="canclePushArticle"'
            style="padding:10px;line-height:20px;"
          >《{{articleObj.title}}》？</span>
        </div>
        <div class="share_button">

          <el-button @click.native='closeAudit()'>取消</el-button>
          <el-button
            type="primary"
            @click.native='sureAudit()'
            v-if='!isLoading'
          >确定</el-button>
          <el-button
            type="primary"
            v-if='isLoading'
          >加载中</el-button>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import * as api from '../../../api'
import logsMixins from '../../../mixins/logs'
export default {

  components: {

  },

  created () {


  },

  mounted () {
    this.$root.eventHub.$on('setAuditModel', (obj, type, articleObj) => {
      this.show = true
      this.auditObj = obj
      this.auditType = type
      this.isLoading = false
      if (articleObj) {
        this.articleObj = articleObj
      }
    })


  },

  destroyed () {
    this.$root.eventHub.$off('setAuditModel')
  },

  data () {
    return {
      show: false,
      auditObj: '',
      auditType: '',
      isLoading: false,
      articleObj: ''
    }
  },
  mixins: [logsMixins],
  updated () {

  },

  computed: {
    userId () {
      return this.$store.state.userinfo.usercode
    },
    token () {
      return this.$store.state.userinfo.token
    },
    seed () {
      return this.$store.state.userinfo.seed
    },
    orgId () {
      return this.$store.state.userinfo.company_id
    }

  },

  methods: {
    closeAudit () {
      this.show = false
      this.isLoading = false
    },
    sureAudit () {
      this.isLoading = true
      if (this.auditType == 'canclePushArticle') {
        var url = ''
        if (this.auditObj.id == 'id_gsh_app') {
          url = 'gsh_app/content_offline'
        }
        if (this.auditObj.id == 'id_sandu_cms_app') {
          url = 'sandu_cms/cancel_push'
        }
        if (this.auditObj.id == 'id_zhongwang_app_v2') {
          url = 'gog_zhong_wang_v2/delete'
        }

        if (this.auditObj.id == 'id_bhws_app') {
          url = 'bhwsapp/offline_article'
        }
        if (this.auditObj.id == 'id_gzu_cms') {
          url = 'gzucms/cancelPublish'
        }
        if (this.auditObj.id == 'id_mrp_cms') {
          url = 'mrp_cms/offlineArticle'
        }
        if (this.auditObj.id == 'id_dcy_wa_app') {
          url = 'dcy_wa_app/offline_article'
        }
        if (this.auditObj.id == 'id_zw_app') {
          url = 'zwapp/cancelArticle'
        }
        if (this.auditObj.id == 'id_gzvcfe_cms') { //贵州财经学院网站推送
          url = 'gzvcfecms/offline_article'
        }
        if (this.auditObj.id == 'id_kaili_xueyuan') { // 凯里学院
          url = 'kaili_xueyuan/offlineArticle'
        }
        var cancleOption = {
          ...this.$store.getters.baseOption,
          "params": {                       // 必须字段： 参数
            "id_content": this.articleObj.id,       // 必须字段： 撤销推送对象 id
            "content_type": "article",    // 必须字段： 撤销推送对象类型  稿件为  article  视频为 video
            "id_article": this.articleObj.id,
            "articleId": this.articleObj.id,
            "articleid": this.articleObj.id
          }
        }
        api._post(_PUSHURL_ + url, cancleOption).then((res) => {
          if (res.code == 200) {
            this.getOperateLogs(this.articleObj.id)
            this.$notify.success({
              title: '成功',
              message: '撤销成功'
            })
            this.articleObj.flag_cancel_push = true
            this.show = false
            this.isLoading = false
          } else {
            this.$notify.error({
              title: '失败',
              message: '撤销失败，请稍后重试'
            })
            this.isLoading = false
          }

        }).catch((error) => {
          console.error(error)
          this.isLoading = false
          this.$notify.error({
            title: '失败',
            message: '撤销失败，请稍后重试'
          })
        })

      }


    }

  },

  watch: {


  }
}

</script>

<style scoped>
@import "../../../static/css/modal";

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
ul,
li {
  list-style: none;
}
.expand-transition {
  transition: all 1s ease;
}
.expand-enter,
.expand-leave {
  opacity: 0;
}
.expand-enter .container,
.expand-leave .container {
  /*margin-top: -800px;*/
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.container {
  transition: all 1s ease;
  width: 420px;
  height: 250px;
  position: absolute;
  left: 40%;
  top: 30%;
  background-color: #ffffff;
  box-shadow: 0px 0px 5px #999;
  border-radius: 5px;
  z-index: 999;
  display: flex;
  flex-direction: column;
}

.container_top {
  width: 100%;
  line-height: 48px;
}
.container_top .iconfont {
  float: right;
  font-size: 20px;
  cursor: pointer;
  line-height: 48px;
  margin-right: 20px;
}
.container_top .container_top_title {
  color: #303133;
  font-size: 14px;
  font-family: "微软雅黑";
  float: left;
}

.delete_info {
  width: 100%;
}

.delete_info span {
  color: #333333;
  font-size: 14px;
  font-family: "微软雅黑";
}

.share_button {
  width: 100%;
  height: 76px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0px;
  left: 0px;
}
.share_button button {
  width: 74px;
  height: 32px;
  padding: 0px;
  line-height: 32px;
  text-align: center;
}

.sure_cancle {
  width: 110px;
  height: 36px;
  border-radius: 4px;
  background: #716bff;
  line-height: 36px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.cancle_operate {
  background: #fff;
  color: #666666;
  border: 1px solid #716bff;
  margin-right: 20px;
}
</style>
